import { ActivableRenderer, ActivableRendererProps, ExpandableBox } from '@optimus-web/helpers';
import { AccordionBodyElement, AccordionBodyProps as AccordionBodyElementProps } from './style';

interface AccordionBodyProps extends ActivableRendererProps, AccordionBodyElementProps {
    children: React.ReactChild;
    expanded: boolean;
}

const AccordionBodyActivatorFunction = ActivableRenderer<React.Component<AccordionBodyProps>, AccordionBodyProps>({
    activePropName: 'expanded',
});

const AccordionBodyComponent = ({ children, expanded, bodyPadding, withBodyBorder, ...other }: AccordionBodyProps) => (
    <ExpandableBox expanded={expanded} {...other}>
        <AccordionBodyElement bodyPadding={bodyPadding} withBodyBorder={withBodyBorder}>
            {children}
        </AccordionBodyElement>
    </ExpandableBox>
);

export default AccordionBodyActivatorFunction(AccordionBodyComponent);
